import { useMutation } from '@apollo/client/react';
import { MARK_ORDER_FILE_PRINTED_MUTATION } from './useMarkOrderFilePrintedMutation.gql';
export const useMarkOrderFilePrintedMutation = () => {
  return useMutation(MARK_ORDER_FILE_PRINTED_MUTATION);
};
